module.exports = __webpack_public_path__ + "img/Item1light.29592da4.svg";